"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTE_FILTER_BUTTON_LIMIT = exports.ATTRIBUTE_FILTER_BITTON_TOOLTIP_ALIGN_POINT = void 0;
var AttributeDropdownList_1 = require("../AttributeDropdown/AttributeDropdownList");
exports.ATTRIBUTE_FILTER_BITTON_TOOLTIP_ALIGN_POINT = [
    { align: "tc bc", offset: { x: 0, y: -2 } },
    { align: "cc tc", offset: { x: 0, y: 10 } },
    { align: "bl tr", offset: { x: -2, y: -8 } },
];
exports.ATTRIBUTE_FILTER_BUTTON_LIMIT = AttributeDropdownList_1.MAX_SELECTION_SIZE + 50;
//# sourceMappingURL=constants.js.map